import * as React from 'react'
import { IconButton } from 'primitives/buttons/icon-button'
import { XCloseIcon } from 'primitives/icons'
import type { ProfileNudgePopup as ProfileNudgePopupType } from 'codegen/types'

import { Link } from '../../components/link'

export function ProfileNudgePopup({ popup }: { popup: ProfileNudgePopupType }) {
  const { title, text, button } = popup
  const { text: buttonText, link } = button
  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  if (!isOpen) {
    return null
  }

  return (
    <div className="bg-service-white fixed left-0 top-[50%] flex w-[250px] flex-col items-center gap-[10px] rounded px-5 py-[30px] text-center shadow-xl">
      <h4 className="text-14 text-secondary-500 pt-[10px] font-bold uppercase">{title}</h4>
      <p className="text-14 font-[500] leading-[19.6px]">{text}</p>
      {link ? (
        <Link
          href={link}
          color="inherit"
          className="bg-primary-500 text-16 text-service-white hover:bg-primary-700 flex h-[45px] w-full items-center justify-center rounded px-5 font-bold uppercase md:h-[40px] md:w-fit"
        >
          {buttonText}
        </Link>
      ) : null}

      <IconButton
        onClick={() => setIsOpen(false)}
        variant="violet"
        className="bg-primary-500 hover:bg-aubergine-500 absolute right-[-18.5px] top-[-15.5px] rounded-full p-[5px] transition-transform"
      >
        <XCloseIcon className="text-service-white h-[26px] w-[26px]" />
      </IconButton>
    </div>
  )
}
